import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const dashboardSchema = new schema.Entity('dashboard', {
    schedule: [schemas.schedule],
    scheduleAdmissions: [schemas.scheduleAdmissions],
    unavailableBlocks: [schemas.unavailableBlocks],
    outstandingNotes: [schemas.outstandingNotes],
    userPreferences: [schemas.userPreferences]
});
